import { formatDateTime } from '../../../utils/format-date-time.util';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useDateHeureCourante = ({
  enabled,
}: Readonly<ResolverParameters>): ResolverResult<string> => {
  if (!enabled) {
    return {
      data: undefined,
      error: null,
      isSuccess: false,
      isLoading: false,
    };
  }

  return {
    data: { generated: formatDateTime(new Date()) },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
